var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13_167)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.9999 1.18332L10.1019 10.7524C10.1019 10.7524 9.83662 11.4159 9.10654 11.0974L4.70709 7.73011C5.29841 7.19855 9.88584 3.07425 10.0865 2.88722C10.3965 2.59777 10.2041 2.42551 9.84365 2.64441L3.06763 6.94754L0.453414 6.06746C0.453414 6.06746 0.0418516 5.92144 0.00224217 5.60293C-0.0376016 5.28441 0.466773 5.11191 0.466773 5.11191L11.124 0.93113C11.124 0.93113 11.9999 0.546287 11.9999 1.18332Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13_167"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.4b75e8e4e817db318fa4ead5fb4c4133.svg";
export { ForwardRef as ReactComponent };